import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconMagnify from 'components/icons/IconMagnify';
import { colorGrayLight2, colorWhite } from 'styles/layout/colors';
const PDPMobileGalleryZoomIcon = t0 => {
  const $ = _c(11);
  const {
    onClick,
    inverted: t1,
    variant
  } = t0;
  const inverted = t1 === undefined ? false : t1;
  const t2 = !inverted;
  const t3 = variant !== "ModularItem";
  const t4 = variant === "ModularItem";
  let t5;
  if ($[0] !== inverted || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = classNames("items-center border-0 rounded-[40px] text-white flex justify-center", {
      "bg-grayOverlay": t2,
      "bg-white border border-solid border-gray-light7": inverted,
      "h-10 w-10": t3,
      "absolute right-[5px] top-[5px] !bg-transparent w-[15px] h-[15px] [&_svg_path]:!fill-gray": t4
    });
    $[0] = inverted;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = inverted ? colorGrayLight2 : colorWhite;
  let t7;
  if ($[5] !== t6) {
    t7 = <IconMagnify width={16} height={16} color={t6} />;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== onClick || $[8] !== t5 || $[9] !== t7) {
    t8 = <button type="button" className={t5} onClick={onClick}>{t7}</button>;
    $[7] = onClick;
    $[8] = t5;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
};
PDPMobileGalleryZoomIcon.propTypes = {
  inverted: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['ModularItem'])
};
export default PDPMobileGalleryZoomIcon;